// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__VL5Ee","content":"styles_content__LU8FK"};